import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonButton, IonContent, IonText } from '@ionic/angular/standalone';

import { BrowserHelper } from '@shared/helpers/browser.helper';
import { Platform } from '@shared/enums/platform.enum';

const STORE_URLS: Record<Platform.ANDROID | Platform.IOS, string> = {
  [Platform.ANDROID]:
      'https://play.google.com/store/apps/details?id=br.com.tarraf.imob',
  [Platform.IOS]:
      'https://apps.apple.com/br/app/tarraf-imobili%C3%A1ria/id1635483823',
};

@Component({
  selector: 'app-force-update-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonContent,
    IonButton,
    IonText,
  ],
  templateUrl: './force-update-modal.component.html',
  styleUrls: ['./force-update-modal.component.scss'],
})
export class ForceUpdateModalComponent {

  /** Passed via ModalController componentProps — public so Ionic can bind it. */
  platform: Platform.ANDROID | Platform.IOS = Platform.IOS;

  protected async openStore(): Promise<void> {
    const url = STORE_URLS[this.platform];
    await BrowserHelper.open({ url });
  }
}
